// extracted by mini-css-extract-plugin
var _1 = "_goldTransactionForm-module__available-balance";
var _2 = "_goldTransactionForm-module__button-container";
var _3 = "_goldTransactionForm-module__button-disabled";
var _4 = "_goldTransactionForm-module__button-subcontainer";
var _5 = "_goldTransactionForm-module__close-button";
var _6 = "_goldTransactionForm-module__close-button-container";
var _7 = "_goldTransactionForm-module__container";
var _8 = "_goldTransactionForm-module__container-justify-end";
var _9 = "_goldTransactionForm-module__disabledButton";
var _a = "_goldTransactionForm-module__error-text";
var _b = "_goldTransactionForm-module__filter-container";
var _c = "_goldTransactionForm-module__form-container";
var _d = "_goldTransactionForm-module__full-width";
var _e = "_goldTransactionForm-module__joint-account-details-container";
var _f = "_goldTransactionForm-module__products-container";
var _10 = "_goldTransactionForm-module__remarks-text";
var _11 = "_goldTransactionForm-module__span-2";
var _12 = "_goldTransactionForm-module__test-button";
export { _1 as "available-balance", _2 as "button-container", _3 as "button-disabled", _4 as "button-subcontainer", _5 as "close-button", _6 as "close-button-container", _7 as "container", _8 as "container-justify-end", _9 as "disabledButton", _a as "error-text", _b as "filter-container", _c as "form-container", _d as "full-width", _e as "joint-account-details-container", _f as "products-container", _10 as "remarks-text", _11 as "span-2", _12 as "test-button" }
